import { useState, useEffect } from 'react'

const useIntersection = (element, rootMargin = '0px', once = false) => {
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const el = element.current
    if (!(el instanceof Element)) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting && once) {
          setIsVisible(entry.isIntersecting)
          observer.unobserve(el)
        } else {
          setIsVisible(entry.isIntersecting)
        }
      },
      { rootMargin },
    )

    observer.observe(el)
    return () => observer.unobserve(el)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return isVisible
}

export default useIntersection
